import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { ISingleStateCustomElement, IStateCustomDataDisplayState } from '../store/nemsisCustomData.types'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'

export function* setPNNVToggle() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const { groupId, stateCustomElements, groupingSequence, customElementId, key, groupKey, _pnnvToggle } =
      customDisplayData
    const stateCustomElementsCopy = [...stateCustomElements]
    const updatedStateCustomElements = stateCustomElementsCopy.map((stateElements: ISingleStateCustomElement) => {
      return {
        ...stateElements,
        groups: stateElements.groups.map((elementGroup) => {
          if (
            elementGroup.groupId !== groupId ||
            elementGroup.groupKey !== groupKey ||
            elementGroup.groupingSequence !== groupingSequence
          ) {
            return elementGroup
          } else {
            const filterCustomElements = elementGroup.customElements.filter(
              (custom, index, arr) =>
                custom.id !== customElementId || arr.findIndex((c) => c.id === customElementId) === index
            )
            const updateCustomElements = _pnnvToggle ? filterCustomElements : elementGroup.customElements

            return {
              ...elementGroup,
              customElements: updateCustomElements.map((customElement) => {
                const isMatch =
                  customElement.id === customElementId && (!customElement.key || customElement.key === key)
                if (isMatch) {
                  return {
                    ...customElement,
                    results: !_pnnvToggle ? customElement.results : [],
                    resultsPNNV: _pnnvToggle ? customElement.resultsPNNV : null,
                    _pnnvToggle,
                  }
                } else {
                  return customElement
                }
              }),
            }
          }
        }),
      }
    })
    yield put(setCustomDisplayData(updatedStateCustomElements))
  } catch (e) {
    yield put(throwPcrException(`setPNNVToggleSaga() error: ${e}`))
  }
}

export function* setPNNVToggleSaga() {
  yield takeLatest([StateCustomDataConstants.SET_PNNV_TOGGLE], performWithMutexHOG, setPNNVToggle)
}
